import axiosInstance from './axiosApi';
import TokenService from './token.service';
import { httpCodes } from '../constants/httpCodes';

const setup = (store) => {
	let userType =
		sessionStorage.getItem('userType') !== null
			? sessionStorage.getItem('userType')
			: '';
	axiosInstance.interceptors.request.use(
		(config) => {
			const token = sessionStorage.getItem('accessToken');
			if (token) {
				config.headers.common['Authorization'] = 'Bearer ' + token;
			} else {
				delete config.headers.common['Authorization'];
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);
	if (userType !== '' && userType === 'internal') {
		let isRefreshing = false;
		let failedQueue = [];
		const processQueue = (error, token = null) => {
			failedQueue.forEach((prom) => {
				if (error) {
					prom.reject(error);
				} else {
					prom.resolve(token);
				}
			});
			failedQueue = [];
		};
		axiosInstance.interceptors.response.use(
			(res) => {
				return res;
			},
			async (err) => {
				const originalConfig = err.config;
				if (originalConfig.url !== 'auth/login' && err.response) {
					if (
						err.response.status === httpCodes.notAuthorized &&
						!originalConfig._retry
					) {
						if (isRefreshing) {
							return new Promise(function(resolve, reject) {
								failedQueue.push({ resolve, reject });
							})
								.then((token) => {
									originalConfig.headers['Authorization'] =
										'Bearer ' + token;
									return axiosInstance(originalConfig);
								})
								.catch((err) => {
									return Promise.reject(err);
								});
						}
						isRefreshing = true;
						originalConfig._retry = true;
						return new Promise(function(resolve, reject) {
							store
								.dispatch('auth/refreshToken')
								.then((response) => {
									const { access_token } = response.data;
									axiosInstance.defaults.headers.common[
										'Authorization'
									] = 'Bearer ' + access_token;
									originalConfig.headers.Authorization =
										'Bearer ' + access_token;
									processQueue(null, access_token);
									resolve(axiosInstance(originalConfig));
								})
								.catch((err) => {
									console.log(err);
									processQueue(err, null);
									reject(err);
								})
								.finally(() => {
									isRefreshing = false;
								});
						});
					}
				}
				return Promise.reject(err);
			}
		);
	}
};
export default setup;
